import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';

import { OnboardingFooter } from '../../../../components/Footer';
import { OnboardingNavigation } from '../../../../components/Navigation';
import { OnboardingPage } from '../../../../components/Page';
import { OnboardingSubtitle } from '../../../../components/Subtitle';
import { OnboardingTitle } from '../../../../components/Title';
import { useOnboarding } from '../../../../context';

import './AppUsers.scss';

export const OnboardingReplikaAppUsers: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Pheon Users',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  const handleBackStep = () => {
    wizard.goToStep('interests');
  };

  return (
    <OnboardingPage background="none" className="onboarding-app-users">
      <OnboardingNavigation dotColor="white" onBack={handleBackStep} />

      <IonContent className="content">
        <div className="image-container">
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png"
            alt="planet"
          />
        </div>
        <div className="description">
          <OnboardingTitle color="white">1,556,867</OnboardingTitle>
          <OnboardingSubtitle color="neutral-white">
            users have already discovered the value that Dialogue brings to
            their lives
          </OnboardingSubtitle>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
